import { useEffect } from 'react';
import { useSearchParams } from '@direct-frontend/modules-router';
import { useMessageToast } from '@/shared/lib/hooks';

export const usePriceChangedToast = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const priceChanged = searchParams.get('priceChanged') ?? false;

    const { showToast } = useMessageToast();

    useEffect(() => {
        if (priceChanged) {
            showToast({ title: 'Цена товара изменилась' });
            searchParams.delete('priceChanged');
            setSearchParams(searchParams, { replace: true });
        }
    }, [priceChanged, showToast, searchParams, setSearchParams]);
};
